<template>
  <div :class="['bto-sb-message', `bto-sb-message-${type}`,'bto-sb-fadeindown']">
  <p v-html="message"></p>
  </div>
</template>

<script>
  export default {
    name: 'InlineMessageComponent',
    props: {
      /**
       * Possible options for type are: "info", "success" and "warning"
       */
      type: {
        type: String,
        default: () => 'info',
        required: true,
      },
      message: {
        type: String,
        default: () => '',
        required: true,
      },
    },
  };
</script>
